import { render } from "./AdminPassword.vue?vue&type=template&id=35763436"
import script from "./AdminPassword.vue?vue&type=script&lang=js"
export * from "./AdminPassword.vue?vue&type=script&lang=js"
script.render = render

export default script